<template>
  <div>
    <px-lista-selecao-fornecedores :comprador="cotacao.comprador"
                                   :is-editing="isEditing"
                                   :produtos="cotacao.produtos"
                                   v-model="cotacao.fornecedores"
                                   @resetfornecedor="emitReset"/>
    <div class="mt-3">
      <v-btn color="primary"
             class="rounded-tag-small normal-btn-text elevation-0"
             :loading="loading"
             :disabled="!cotacao.fornecedores.length"
             @click="onClickEnviarCotacao">
        Enviar
      </v-btn>
      <v-btn v-if="showRascunho"
             class="rounded-tag-small elevation-0 normal-btn-text ml-2"
             :disabled="loading"
             @click="onClickSaveDraft">
        Salvar rascunho
      </v-btn>
      <v-btn text
             class="normal-btn-text"
             :disabled="loading"
             @click="onClickPrevious">
        Voltar
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cotacao: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: false,
    },
    showRascunho: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    emitReset() {
      this.$emit('reset-fornecedor');
    },
    onClickEnviarCotacao() {
      this.$emit('enviar-cotacao');
    },
    onClickSaveDraft() {
      this.$emit('save-draft');
    },
    onClickPrevious() {
      this.$emit('previous');
    },
  },
};
</script>
